import kaplay from 'kaplay';

import { loadAssets } from './assets.js';
import { createGameScene } from './gameLogic.js';
import { createIntroScene } from './introScene.js';

// 初始化KAPLAY引擎
const k = kaplay({
    width: 430,
    height: 932,
    background: [135, 190, 85]
});

// 加载游戏资源
loadAssets(k);

// 创建介绍场景
k.scene('intro', () => {
    const introLogic = createIntroScene(k);
    introLogic.initIntro();
});

// 创建游戏主场景
k.scene('game', () => {
    const gameLogic = createGameScene(k);
    gameLogic.initGame();
});

// 启动介绍场景
k.go('intro');
